import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();
  const [selectedService, setSelectedService] = useState<number | null>(null);

  const services = [
    {
      icon: 'ri-hospital-line',
      title: t('services.hospital.title'),
      description: t('services.hospital.desc'),
      features: ['Enfeksiyon Kontrolü', 'Tıbbi Atık İmhası', 'Ameliyathane Temizliği', 'Hasta Odası Dezenfeksiyonu'],
      image: 'https://public.readdy.ai/ai/img_res/7d15597a7ba9e0b041ee63fa7c4acebb.jpg',
      detailedInfo: {
        intro: 'Sağlık tesislerinde hijyen ve sterilizasyon hayati önem taşır. Roba Temizlik olarak, hastaneler ve sağlık merkezleri için özel olarak tasarlanmış temizlik protokollerimizle hasta güvenliğini en üst düzeyde tutuyoruz.',
        benefits: [
          'Sağlık Bakanlığı onaylı dezenfektan ürünler',
          'Hastane enfeksiyonlarını %95 oranında azaltma',
          'Ameliyathane ve yoğun bakım ünitelerinde özel sterilizasyon',
          'Tıbbi atık yönetimi ve güvenli imha',
          'HEPA filtreli ekipmanlar ile hava kalitesi kontrolü',
          '7/24 acil müdahale ekibi'
        ],
        process: 'Eğitimli personelimiz, hastane hijyen standartlarına tam uyum sağlayarak çalışır. Her temizlik sonrası detaylı raporlama yapılır ve kalite kontrol testleri uygulanır.',
        detailImage: 'https://readdy.ai/api/search-image?query=Professional%20medical%20facility%20deep%20cleaning%20service%2C%20healthcare%20workers%20in%20protective%20gear%20sanitizing%20hospital%20operating%20room%2C%20advanced%20medical%20grade%20disinfection%20equipment%2C%20sterile%20hospital%20environment%2C%20infection%20control%20protocols%2C%20pristine%20white%20medical%20facility%20with%20modern%20equipment&width=1000&height=600&seq=service-detail-001&orientation=landscape'
      }
    },
    {
      icon: 'ri-store-2-line',
      title: t('services.mall.title'),
      description: t('services.mall.desc'),
      features: ['Zemin Bakımı ve Cilalama', 'Tuvalet Dezenfeksiyonu', 'Yemek Alanı Temizliği', 'Cam ve Pencere Temizliği'],
      image: 'https://readdy.ai/api/search-image?query=Large%20modern%20shopping%20mall%20interior%20being%20cleaned%20by%20professional%20team%2C%20sparkling%20polished%20marble%20floors%2C%20bright%20retail%20space%2C%20commercial%20cleaning%20equipment%2C%20pristine%20shopping%20center%2C%20contemporary%20architecture%2C%20wide%20open%20atrium%2C%20professional%20maintenance%20service&width=600&height=400&seq=service-002&orientation=landscape',
      detailedInfo: {
        intro: 'Alışveriş merkezleri yüksek trafikli alanlardır ve sürekli temiz görünüm müşteri memnuniyeti için kritiktir. Ziyaretçilerinize her zaman temiz ve hijyenik bir ortam sunuyoruz.',
        benefits: [
          'Gece ve gündüz esnek çalışma saatleri',
          'Yüksek trafikli alanlarda özel bakım',
          'Mermer ve granit zemin cilalama',
          'Cam cephe ve vitrin temizliği',
          'Tuvalet ve ortak alanların saatlik kontrolü',
          'Acil müdahale ekibi (dökülen sıvılar, vb.)'
        ],
        process: 'AVM yönetiminizle koordineli çalışarak, müşteri trafiğini etkilemeden temizlik hizmetlerini gerçekleştiriyoruz. Özel etkinlikler ve yoğun dönemler için ekstra destek sağlıyoruz.',
        detailImage: 'https://readdy.ai/api/search-image?query=Professional%20shopping%20mall%20cleaning%20crew%20working%20in%20large%20modern%20retail%20center%2C%20team%20polishing%20expansive%20marble%20floors%20with%20industrial%20equipment%2C%20bright%20contemporary%20shopping%20center%20with%20multiple%20levels%2C%20pristine%20commercial%20space%20maintenance%2C%20professional%20janitorial%20service%20in%20action&width=1000&height=600&seq=service-detail-002&orientation=landscape'
      }
    },
    {
      icon: 'ri-hammer-line',
      title: t('services.construction.title'),
      description: t('services.construction.desc'),
      features: ['Moloz Temizleme', 'Toz ve Boya Temizliği', 'Pencere Yıkama', 'Son Dokunuş Detayları'],
      image: 'https://readdy.ai/api/search-image?query=Post%20construction%20cleaning%20service%20in%20newly%20built%20commercial%20building%2C%20professional%20cleaners%20removing%20dust%20and%20debris%2C%20modern%20office%20space%20under%20final%20cleanup%2C%20construction%20site%20cleaning%2C%20pristine%20new%20building%20interior%2C%20professional%20cleaning%20team%20with%20equipment&width=600&height=400&seq=service-003&orientation=landscape',
      detailedInfo: {
        intro: 'İnşaat ve renovasyon sonrası temizlik, binanızın kullanıma hazır hale gelmesi için kritik bir adımdır. Profesyonel ekibimiz, en ince detaylara kadar temizlik yaparak mekanınızı teslime hazır hale getirir.',
        benefits: [
          'Tüm inşaat artıklarının güvenli temizliği',
          'Boya, alçı ve çimento kalıntılarının giderilmi',
          'Pencere ve cam yüzeylerin profesyonel temizliği',
          'Zemin koruma filmlerinin kaldırılması ve cilalama',
          'Elektrik ve aydınlatma armatürlerinin temizliği',
          'Hızlı teslimat garantisi'
        ],
        process: 'İnşaat ekibinizle koordineli çalışarak, projenizin tamamlanma sürecini hızlandırıyoruz. Kaba temizlikten ince detaylara kadar tüm aşamaları kapsayan hizmet sunuyoruz.',
        detailImage: 'https://readdy.ai/api/search-image?query=Detailed%20post%20construction%20cleaning%20in%20modern%20commercial%20building%2C%20professional%20cleaning%20team%20removing%20construction%20dust%20and%20debris%2C%20newly%20built%20office%20space%20being%20prepared%20for%20occupancy%2C%20industrial%20cleaning%20equipment%2C%20pristine%20new%20building%20interior%20transformation%2C%20before%20and%20after%20construction%20cleanup&width=1000&height=600&seq=service-detail-003&orientation=landscape'
      }
    },
    {
      icon: 'ri-building-line',
      title: t('services.office.title'),
      description: t('services.office.desc'),
      features: ['Günlük Temizlik Servisi', 'Halı Temizliği', 'Dinlenme Alanı Bakımı', 'Toplantı Odası Düzeni'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20office%20cleaning%20service%20in%20modern%20corporate%20building%2C%20cleaner%20vacuuming%20carpet%20in%20bright%20contemporary%20office%20space%2C%20commercial%20janitorial%20service%2C%20clean%20business%20environment%2C%20professional%20maintenance%2C%20sleek%20office%20interior%20with%20glass%20walls&width=600&height=400&seq=service-004&orientation=landscape',
      detailedInfo: {
        intro: 'Temiz ve düzenli bir ofis ortamı, çalışan verimliliğini artırır ve profesyonel bir imaj oluşturur. Kurumsal ofisler için özel olarak tasarlanmış temizlik programlarımızla işyerinizi her zaman temiz tutuyoruz.',
        benefits: [
          'Esnek çalışma saatleri (mesai öncesi/sonrası)',
          'Çalışma masaları ve ortak alanların günlük temizliği',
          'Mutfak ve dinlenme alanlarının hijyenik bakımı',
          'Halı ve zemin bakımı',
          'Cam bölme ve pencerelerin temizliği',
          'Çöp toplama ve geri dönüşüm yönetimi'
        ],
        process: 'Ofis yöneticinizle birlikte özel bir temizlik planı oluşturuyoruz. Düzenli kalite kontrolleri ve geri bildirim toplantılarıyla hizmet kalitemizi sürekli iyileştiriyoruz.',
        detailImage: 'https://readdy.ai/api/search-image?query=Comprehensive%20office%20building%20maintenance%20service%2C%20professional%20cleaning%20team%20working%20in%20modern%20corporate%20office%20environment%2C%20cleaners%20maintaining%20pristine%20business%20workspace%2C%20contemporary%20office%20interior%20with%20glass%20partitions%2C%20commercial%20building%20janitorial%20service%2C%20professional%20office%20cleaning%20in%20action&width=1000&height=600&seq=service-detail-004&orientation=landscape'
      }
    },
    {
      icon: 'ri-building-4-line',
      title: 'Dış Cephe Temizliği',
      description: 'Binaların dış cephelerinin profesyonel temizliği. Cam cepheler, alüminyum kompozit paneller, mermer ve granit yüzeyler için özel ekipman ve tekniklerle hizmet veriyoruz.',
      features: ['Cam Cephe Temizliği', 'Yüksekte Çalışma Sistemleri', 'Kompozit Panel Bakımı', 'Mermer ve Granit Yüzey Temizliği'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20building%20facade%20cleaning%20service%20with%20workers%20on%20rope%20access%20system%20cleaning%20modern%20glass%20curtain%20wall%20skyscraper%20exterior%2C%20high%20rise%20window%20cleaning%2C%20commercial%20building%20exterior%20maintenance%2C%20pristine%20glass%20facade%2C%20professional%20facade%20cleaning%20equipment%2C%20urban%20commercial%20building%20with%20clean%20simple%20light%20colored%20background&width=600&height=400&seq=service-010&orientation=landscape',
      detailedInfo: {
        intro: 'Binanızın dış görünümü, işletmenizin ilk izlenimini oluşturur. Profesyonel dış cephe temizliği ile binanızın değerini korur ve prestijini artırırız. Yüksekte çalışma sertifikalarına sahip uzman ekibimizle güvenli ve etkili temizlik hizmeti sunuyoruz.',
        benefits: [
          'Yüksekte çalışma sertifikalı profesyonel ekip',
          'İp erişim sistemi (rope access) ve platform kullanımı',
          'Cam cephe ve pencere temizliğinde özel deterjanlar',
          'Alüminyum kompozit panel koruma ve temizliği',
          'Mermer, granit ve doğal taş yüzey bakımı',
          'Yüksek basınçlı yıkama ve detaylı temizlik',
          'Tam sigorta kapsamı ve güvenlik protokolleri'
        ],
        process: 'Öncelikle binanızın cephe yapısını ve yüksekliğini inceleyerek en uygun temizlik yöntemini belirliyoruz. İp erişim sistemi veya platform kullanarak güvenli şekilde çalışıyoruz. Tüm işlemler sırasında bina sakinleri ve çevre güvenliği önceliğimizdir.',
        detailImage: 'https://readdy.ai/api/search-image?query=Detailed%20professional%20facade%20cleaning%20service%20on%20modern%20commercial%20building%2C%20team%20of%20workers%20using%20rope%20access%20and%20platforms%20cleaning%20glass%20curtain%20wall%20and%20composite%20panels%2C%20high%20rise%20building%20exterior%20maintenance%2C%20pristine%20skyscraper%20facade%20cleaning%2C%20professional%20building%20washing%20service%2C%20commercial%20building%20exterior%20with%20clean%20simple%20light%20colored%20background&width=1000&height=600&seq=service-detail-010&orientation=landscape'
      }
    },
    {
      icon: 'ri-school-line',
      title: 'Okul ve Eğitim Kurumu Temizliği',
      description: 'Öğrenci ve personel sağlığını önceleyerek okul, üniversite ve eğitim merkezleri için güvenli ve hijyenik ortamlar sağlıyoruz. Çocuk dostu temizlik ürünleri kullanıyoruz.',
      features: ['Sınıf Temizliği', 'Oyun Alanı Dezenfeksiyonu', 'Yemekhane Hijyeni', 'Tuvalet ve Ortak Alan Bakımı'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20school%20cleaning%20service%20in%20bright%20modern%20classroom%2C%20cleaner%20sanitizing%20desks%20and%20educational%20equipment%2C%20safe%20child-friendly%20cleaning%20products%2C%20pristine%20educational%20environment%2C%20school%20hallway%20maintenance%2C%20professional%20educational%20facility%20cleaning&width=600&height=400&seq=service-007&orientation=landscape',
      detailedInfo: {
        intro: 'Eğitim kurumlarında hijyen, öğrenci ve personel sağlığı için hayati önem taşır. Çocuk dostu, toksik olmayan ürünler kullanarak güvenli öğrenme ortamları oluşturuyoruz.',
        benefits: [
          'Çocuk güvenliği sertifikalı temizlik ürünleri',
          'Sınıf ve koridorların günlük dezenfeksiyonu',
          'Oyun alanları ve spor salonlarının özel bakımı',
          'Yemekhane ve mutfak hijyeni',
          'Tuvalet ve lavabolarda saatlik kontrol',
          'Grip ve hastalık sezonlarında ekstra dezenfeksiyon'
        ],
        process: 'Okul yönetimiyle koordineli çalışarak, eğitim programını aksatmadan temizlik hizmetlerini gerçekleştiriyoruz. Ders saatleri dışında yoğun temizlik, ders saatlerinde ise hızlı müdahaleler yapıyoruz.',
        detailImage: 'https://readdy.ai/api/search-image?query=Comprehensive%20school%20cleaning%20and%20sanitization%20service%2C%20professional%20team%20cleaning%20bright%20modern%20educational%20facility%2C%20child-safe%20cleaning%20products%20being%20used%20in%20classroom%2C%20pristine%20school%20environment%20with%20sanitized%20desks%20and%20floors%2C%20educational%20institution%20maintenance%2C%20safe%20learning%20environment&width=1000&height=600&seq=service-detail-007&orientation=landscape'
      }
    },
    {
      icon: 'ri-dumbbell-line',
      title: 'Spor Salonu Temizliği',
      description: 'Fitness merkezleri ve spor tesisleri için özel hijyen protokolleri. Ekipman dezenfeksiyonu, soyunma odası temizliği ve yüksek trafik alanlarının bakımı.',
      features: ['Spor Ekipmanı Dezenfeksiyonu', 'Soyunma Odası Hijyeni', 'Duş Alanı Temizliği', 'Zemin Bakımı ve Dezenfeksiyon'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20gym%20cleaning%20service%20in%20modern%20fitness%20center%2C%20cleaner%20sanitizing%20exercise%20equipment%20and%20weights%2C%20bright%20contemporary%20fitness%20facility%2C%20professional%20sports%20facility%20maintenance%2C%20pristine%20workout%20environment%2C%20commercial%20gym%20cleaning%20with%20specialized%20equipment&width=600&height=400&seq=service-008&orientation=landscape',
      detailedInfo: {
        intro: 'Spor salonları yüksek temas ve ter nedeniyle özel hijyen gerektiren alanlardır. Üyelerinizin sağlığını korumak için spor ekipmanları ve ortak alanlar için özel temizlik protokolleri uyguluyoruz.',
        benefits: [
          'Spor ekipmanlarının her kullanım sonrası dezenfeksiyonu',
          'Soyunma odası ve duş alanlarının saatlik temizliği',
          'Anti-bakteriyel zemin temizliği',
          'Ayna ve cam yüzeylerin lekesiz temizliği',
          'Havalandırma sistemlerinin düzenli bakımı',
          'Koku kontrolü ve hava tazeleme'
        ],
        process: 'Spor salonunuzun yoğun saatlerini dikkate alarak, üye deneyimini etkilemeden sürekli temizlik hizmeti sunuyoruz. Ekipman dezenfeksiyonu için hızlı kuruma süreli ürünler kullanıyoruz.',
        detailImage: 'https://readdy.ai/api/search-image?query=Detailed%20gym%20and%20fitness%20center%20cleaning%20service%2C%20professional%20team%20sanitizing%20workout%20equipment%20and%20free%20weights%2C%20modern%20fitness%20facility%20deep%20cleaning%2C%20pristine%20sports%20center%20with%20clean%20exercise%20machines%2C%20commercial%20gym%20maintenance%2C%20hygienic%20fitness%20environment&width=1000&height=600&seq=service-detail-008&orientation=landscape'
      }
    },
    {
      icon: 'ri-bank-line',
      title: 'Banka ve Finans Kurumu Temizliği',
      description: 'Bankalar ve finans kurumları için güvenlik odaklı temizlik hizmetleri. Müşteri alanları, ATM bölümleri ve ofis alanlarının profesyonel bakımı.',
      features: ['Müşteri Hizmet Alanları', 'ATM Bölümü Temizliği', 'Güvenlik Kamerası Temizliği', 'Cam Vitrin Bakımı'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20bank%20cleaning%20service%20in%20modern%20financial%20institution%2C%20cleaner%20maintaining%20pristine%20banking%20hall%20with%20marble%20floors%2C%20contemporary%20bank%20interior%2C%20professional%20financial%20facility%20cleaning%2C%20secure%20banking%20environment%2C%20commercial%20bank%20maintenance%20service&width=600&height=400&seq=service-009&orientation=landscape',
      detailedInfo: {
        intro: 'Finans kurumlarında profesyonel görünüm ve güvenlik çok önemlidir. Güvenlik protokollerine tam uyum sağlayarak, müşterilerinize güven veren temiz ve düzenli bir ortam oluşturuyoruz.',
        benefits: [
          'Güvenlik izni olan sertifikalı personel',
          'Müşteri alanlarının günlük temizliği',
          'ATM ve kasa bölümlerinin özel bakımı',
          'Cam vitrin ve kapıların lekesiz temizliği',
          'Bekleme alanları ve danışma masalarının dezenfeksiyonu',
          'Gizlilik ve güvenlik protokollerine tam uyum'
        ],
        process: 'Banka güvenlik ekibinizle koordineli çalışarak, tüm güvenlik prosedürlerine uygun şekilde temizlik hizmetlerini gerçekleştiriyoruz. Personelimiz kimlik kontrolü ve güvenlik eğitiminden geçer.',
        detailImage: 'https://readdy.ai/api/search-image?query=Professional%20banking%20facility%20cleaning%20service%2C%20security-cleared%20cleaning%20team%20maintaining%20modern%20financial%20institution%2C%20pristine%20bank%20interior%20with%20polished%20marble%20floors%2C%20professional%20bank%20maintenance%2C%20secure%20financial%20facility%20cleaning%2C%20contemporary%20banking%20hall&width=1000&height=600&seq=service-detail-009&orientation=landscape'
      }
    },
    {
      icon: 'ri-hotel-line',
      title: 'Otel ve Konaklama Temizliği',
      description: 'Oteller, tatil köyleri ve konaklama tesisleri için premium temizlik hizmetleri. Misafir memnuniyetini sağlamak için en yüksek standartları koruyoruz.',
      features: ['Misafir Odası Değişimi', 'Lobi ve Ortak Alanlar', 'Çamaşırhane Hizmetleri', 'Derin Temizlik'],
      image: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20room%20being%20cleaned%20by%20professional%20housekeeper%2C%20pristine%20white%20linens%20on%20bed%2C%20elegant%20hospitality%20cleaning%20service%2C%20five%20star%20hotel%20maintenance%2C%20immaculate%20guest%20room%2C%20professional%20hotel%20cleaning%2C%20bright%20modern%20hotel%20interior&width=600&height=400&seq=service-005&orientation=landscape',
      detailedInfo: {
        intro: 'Otel misafirlerinizin konforlu ve hijyenik bir ortamda kalması için en yüksek standartlarda temizlik hizmeti sunuyoruz. Her oda, misafir gelmeden önce detaylı kontrol edilir.',
        benefits: [
          'Misafir odalarının profesyonel değişimi',
          'Çarşaf ve havlu değişimi ile yatak yapımı',
          'Banyo ve tuvalet dezenfeksiyonu',
          'Lobi ve ortak alanların sürekli bakımı',
          'Restoran ve kahvaltı salonlarının temizliği',
          'Özel etkinlik ve toplantı salonları hazırlığı'
        ],
        process: 'Otel yönetiminizle entegre çalışarak, check-out ve check-in saatlerine uygun hızlı oda değişimi yapıyoruz. Misafir memnuniyeti anketlerine göre hizmetimizi sürekli iyileştiriyoruz.',
        detailImage: 'https://readdy.ai/api/search-image?query=Professional%20hotel%20housekeeping%20service%20in%20luxury%20accommodation%2C%20cleaning%20team%20preparing%20pristine%20guest%20rooms%20with%20fresh%20white%20linens%2C%20five%20star%20hotel%20room%20maintenance%2C%20immaculate%20hospitality%20cleaning%2C%20elegant%20hotel%20interior%2C%20professional%20hotel%20cleaning%20service%20in%20action&width=1000&height=600&seq=service-detail-005&orientation=landscape'
      }
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Restoran ve Mutfak Temizliği',
      description: 'Sağlık kodu uyumluluğuna odaklanan yemek servisi tesisi temizliği. Mutfaklar, yemek alanları ve yemek hazırlama alanlarının derin temizliği.',
      features: ['Mutfak Derin Temizlik', 'Yağ Tuzağı Temizliği', 'Yemek Alanı Bakımı', 'Sağlık Kodu Uyumluluğu'],
      image: 'https://readdy.ai/api/search-image?query=Commercial%20restaurant%20kitchen%20being%20deep%20cleaned%20by%20professional%20team%2C%20stainless%20steel%20surfaces%20sparkling%20clean%2C%20professional%20food%20service%20cleaning%2C%20industrial%20kitchen%20maintenance%2C%20pristine%20commercial%20kitchen%2C%20health%20code%20compliant%20cleaning%20service&width=600&height=400&seq=service-006&orientation=landscape',
      detailedInfo: {
        intro: 'Restoran ve mutfak hijyeni, müşteri sağlığı ve işletme itibarı için kritiktir. Sağlık Bakanlığı standartlarına tam uyumlu temizlik hizmetleriyle işletmenizi denetimlere hazır tutuyoruz.',
        benefits: [
          'Sağlık Bakanlığı standartlarına uygun temizlik',
          'Mutfak ekipmanlarının derin temizliği',
          'Yağ ve kir birikintilerinin profesyonel temizliği',
          'Soğuk hava depoları ve buzdolaplarının hijyeni',
          'Yemek hazırlama yüzeylerinin dezenfeksiyonu',
          'Denetim öncesi özel hazırlık hizmeti'
        ],
        process: 'Restoran çalışma saatlerinize uygun olarak, mutfak kapalıyken derin temizlik yapıyoruz. Düzenli haftalık bakım ve aylık derin temizlik programları sunuyoruz.',
        detailImage: 'https://readdy.ai/api/search-image?query=Professional%20commercial%20kitchen%20deep%20cleaning%20service%2C%20cleaning%20team%20sanitizing%20industrial%20restaurant%20kitchen%2C%20stainless%20steel%20surfaces%20sparkling%20clean%2C%20food%20service%20facility%20maintenance%2C%20health%20code%20compliant%20kitchen%20cleaning%2C%20pristine%20commercial%20kitchen%20environment&width=1000&height=600&seq=service-detail-006&orientation=landscape'
      }
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t('services.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <div className="w-14 h-14 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${service.icon} text-3xl text-teal-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-gray-700">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
                <button 
                  onClick={() => setSelectedService(index)}
                  className="mt-6 w-full bg-teal-600 text-white py-3 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Daha Fazla Bilgi
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Detaylı Bilgi Popup */}
      {selectedService !== null && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4 overflow-y-auto"
          onClick={() => setSelectedService(null)}
        >
          <div
            className="bg-white rounded-2xl max-w-4xl w-full my-8 overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Başlık ve Kapat Butonu */}
            <div className="relative">
              <img
                src={services[selectedService].detailedInfo.detailImage}
                alt={services[selectedService].title}
                className="w-full h-64 object-cover object-top"
              />
              <button
                className="absolute top-4 right-4 w-10 h-10 bg-white/90 hover:bg-white rounded-full flex items-center justify-center text-gray-800 transition-colors cursor-pointer shadow-lg"
                onClick={() => setSelectedService(null)}
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center">
                    <i className={`${services[selectedService].icon} text-2xl text-white`}></i>
                  </div>
                  <h3 className="text-3xl font-bold text-white">{services[selectedService].title}</h3>
                </div>
              </div>
            </div>

            {/* İçerik */}
            <div className="p-8">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                {services[selectedService].detailedInfo.intro}
              </p>

              <h4 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-star-line text-teal-600"></i>
                Hizmet Avantajları
              </h4>
              <ul className="grid md:grid-cols-2 gap-3 mb-6">
                {services[selectedService].detailedInfo.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-2 text-gray-700">
                    <i className="ri-checkbox-circle-fill text-teal-600 text-xl mt-0.5"></i>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>

              <h4 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <i className="ri-settings-3-line text-teal-600"></i>
                Çalışma Sürecimiz
              </h4>
              <p className="text-gray-700 leading-relaxed mb-6">
                {services[selectedService].detailedInfo.process}
              </p>

              <div className="bg-teal-50 rounded-xl p-6 border-l-4 border-teal-600">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-2xl text-teal-600 mt-1"></i>
                  <div>
                    <h5 className="font-bold text-gray-900 mb-2">Ücretsiz Keşif ve Teklif</h5>
                    <p className="text-gray-700">
                      Tesisınizi ziyaret ederek ihtiyaçlarınızı analiz ediyor ve size özel bir teklif hazırlıyoruz. 
                      Detaylı bilgi almak için bizimle iletişime geçin.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex gap-4">
                <button
                  onClick={() => {
                    setSelectedService(null);
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="flex-1 bg-teal-600 text-white py-3 px-6 rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer font-semibold"
                >
                  <i className="ri-phone-line mr-2"></i>
                  İletişime Geç
                </button>
                <button
                  onClick={() => setSelectedService(null)}
                  className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer font-semibold"
                >
                  Kapat
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
